import React from 'react'
import { Box, Typography } from '@mui/material'
import { SvgIconProps } from '@mui/material'

interface SrpTipBannerProps {
    text: string
    Icon: React.FC<SvgIconProps>
}

const SrpTipBanner: React.FC<SrpTipBannerProps> = ({ text, Icon }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.25,
                p: 2,
                mb: 2,
                bgcolor: 'common.white',
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: 1.5,
                height: 80,
                width: '100%'
            }}
        >
            <Box
                sx={{
                    flexShrink: 0,
                    animation: 'fadeIn 0.3s ease-in',
                    '@keyframes fadeIn': {
                        from: { opacity: 0 },
                        to: { opacity: 1 }
                    }
                }}
            >
                <Icon sx={{ fontSize: { xs: 24, md: 32 } }} />
            </Box>
            <Typography
                sx={{
                    fontSize: { xs: 12, md: 14 },
                    fontWeight: 600,
                    color: 'text.primary',
                    lineHeight: 1.5,
                    animation: 'fadeIn 0.3s ease-in',
                    '@keyframes fadeIn': {
                        from: { opacity: 0 },
                        to: { opacity: 1 }
                    }
                }}
            >
                {text}
            </Typography>
        </Box>
    )
}

export { SrpTipBanner }
export type { SrpTipBannerProps }
